// mainBannerAnimate
export default function mainBannerAnimate() {
	let banners = document.querySelectorAll('.main-banner__bg--animate-2'),
		startX = -400,
		w = document.documentElement.offsetWidth;

	if(banners.length) {
		banners.forEach((banner) => {
			banner.addEventListener('mousemove', function(evt){
				var posX = Math.round(evt.clientX / w * startX)
				banner.style.opacity = (100 + posX) / 100
			})
		})
	}

} 